export const trackUmami = (event, data = {}) => {
  window.umami?.track(event, data)
}
